import React, { useState } from 'react'
import Kartu from '../components/Card'
import Form from '../components/Form'
import Swal from 'sweetalert2'
import {
    useRouteMatch,
    //Link,
    Switch,
    Route,
    useHistory
} from 'react-router-dom'

import {
    Detail
} from './index'

import { setLoading, setfPic } from '../store/actions/picAction'
import { useDispatch, useSelector } from 'react-redux'

export default () => {
    const dispatch = useDispatch()
    const { fpics, loading } = useSelector(state => state.picReducer) 

    const {path, url} = useRouteMatch()
    const history = useHistory()
    function onClick(id){
        history.push(`${url}/${id}`)
    }

    const [pics, setPics] = useState([])

    function onFormSubmit(newData){
        setPics(pics.concat(newData))
        console.log(pics, "...pics onform submit")
    }

    function RemoveCard(id){
        const items = pics.filter(pic=>pic.id!==id)
        setPics(items)
    }

    function addFav(pic){
        setLoading(true)
        console.log(fpics, "....fpic in picture")
        let status = true
        for (let i=0; i<fpics.length; i++){
            if (pic.date === fpics[i].date){
                console.log('sudah ada')
                status = false
                break
            }
        }
        if (status===false){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'You have this pic in your favourites!'
              })
        } else {
            console.log(pic,"....pic in picture")
            fpics.push(pic)
            dispatch(setfPic(fpics))
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Added the pic in favourite!'
              })
        }
        setLoading(false)
    }

    return (
        <>   
            <Form onSubmit={onFormSubmit} pics={pics}></Form>
            <hr/>
            {loading && <p>Loading ..... </p>}
            <div id="cardgroup">
            {pics.map((pic, idx)=>(
                <div key={idx} id="card">
                    <button onClick={()=>onClick(pic.date)}>Detail</button>
                    <button onClick={()=>addFav(pic)}>Favorite</button>
                    <Kartu pic={pic} RemoveCard={RemoveCard}></Kartu>
                </div>
            ))}
            </div>
            <Switch>
                <Route path={`${path}/:date`}>
                    <Detail/>
                </Route>
            </Switch>
        </>
    )
}